import {EnergyBalanceResponse} from '../../../../api/models/energy-balance-response';

export const SAMPLE_SINGLE_DAY: EnergyBalanceResponse = {
  'date': '2025-06-12T00:00:00.000Z',
  'energyToGrid': 31.2,
  'energyToBattery': 7.9,
  'energyFromSolar': 37.59303,
  'energyConsumed': 2.08957,
  'energyFromBattery': 2.7,
  'energyFromGrid': 0.9,
  'selfConsumptionFromProduction': 1.50697,
  'selfConsumptionFromConsumption': 1.51043,
};

export const SAMPLE_WEEK: EnergyBalanceResponse[] = [
  {
    'date': '2025-04-21',
    'energyToGrid': 89.4,
    'energyToBattery': 11.0,
    'energyFromSolar': 89.08127,
    'energyConsumed': 1.18127,
    'energyFromBattery': 10.5,
    'energyFromGrid': 2,
    'selfConsumptionFromProduction': 11.31873,
    'selfConsumptionFromConsumption': 11.31873,
  },
  {
    'date': '2025-04-22',
    'energyToGrid': 40.1,
    'energyToBattery': 17.1,
    'energyFromSolar': 355.8144,
    'energyConsumed': 390.2144,
    'energyFromBattery': 16.8,
    'energyFromGrid': 6,
    'selfConsumptionFromProduction': 298.6144,
    'selfConsumptionFromConsumption': 367.4144,
  },
  {
    'date': '2025-04-23',
    'energyToGrid': 73.7,
    'energyToBattery': 18.0,
    'energyFromSolar': 47.78481,
    'energyConsumed': 115.58481,
    'energyFromBattery': 20.9,
    'energyFromGrid': 3,
    'selfConsumptionFromProduction': 43.91519,
    'selfConsumptionFromConsumption': 91.68481,
  },
  {
    'date': '2025-04-24',
    'energyToGrid': 19,
    'energyToBattery': 23.0,
    'energyFromSolar': 50.39947,
    'energyConsumed': 32.79947,
    'energyFromBattery': 20.3,
    'energyFromGrid': 4.1,
    'selfConsumptionFromProduction': 8.39947,
    'selfConsumptionFromConsumption': 8.39947,
  },
  {
    'date': '2025-04-25',
    'energyToGrid': 13.7,
    'energyToBattery': 12.5,
    'energyFromSolar': 24.56155,
    'energyConsumed': 58.76155,
    'energyFromBattery': 35.6,
    'energyFromGrid': 24.8,
    'selfConsumptionFromProduction': 1.63845,
    'selfConsumptionFromConsumption': 1.63845,
  },
  {
    'date': '2025-04-26',
    'energyToGrid': 64.4,
    'energyToBattery': 31.2,
    'energyFromSolar': 89.6802,
    'energyConsumed': 2.3802,
    'energyFromBattery': 3.8,
    'energyFromGrid': 4.5,
    'selfConsumptionFromProduction': 5.9198,
    'selfConsumptionFromConsumption': 5.9198,
  },
  {
    'date': '2025-04-27',
    'energyToGrid': 117.7,
    'energyToBattery': 21.2,
    'energyFromSolar': 126.51314,
    'energyConsumed': 9.61314,
    'energyFromBattery': 20.5,
    'energyFromGrid': 1.5,
    'selfConsumptionFromProduction': 12.38686,
    'selfConsumptionFromConsumption': 12.38686,
  },
];

export const SAMPLE_MONTH : EnergyBalanceResponse[]= [
  {
    'date': '2025-06-01T00:01:04.000+02:00',
    'energyToGrid': 101.7,
    'energyToBattery': 9.2,
    'energyFromSolar': 100.98236,
    'energyConsumed': 22.56449,
    'energyFromBattery': 9.0,
    'energyFromGrid': 1.8,
    'selfConsumptionFromProduction': 9.91764,
    'selfConsumptionFromConsumption': 11.76449,
  },
  {
    'date': '2025-06-02T00:01:24.000+02:00',
    'energyToGrid': 31.6,
    'energyToBattery': 22.3,
    'energyFromSolar': 92.44394,
    'energyConsumed': 90.99303,
    'energyFromBattery': 37.0,
    'energyFromGrid': 7.6,
    'selfConsumptionFromProduction': 38.54394,
    'selfConsumptionFromConsumption': 46.39303,
  },
  {
    'date': '2025-06-03T00:01:44.000+02:00',
    'energyToGrid': 78.2,
    'energyToBattery': 27.8,
    'energyFromSolar': 105.48332,
    'energyConsumed': 75.31069,
    'energyFromBattery': 38.8,
    'energyFromGrid': 16.3,
    'selfConsumptionFromProduction': 0.51668,
    'selfConsumptionFromConsumption': 20.21069,
  },
  {
    'date': '2025-06-04T00:01:44.000+02:00',
    'energyToGrid': 29.9,
    'energyToBattery': 32.5,
    'energyFromSolar': 115.94817,
    'energyConsumed': 84.68564,
    'energyFromBattery': 21.7,
    'energyFromGrid': 5.4,
    'selfConsumptionFromProduction': 53.54817,
    'selfConsumptionFromConsumption': 57.58564,
  },
  {
    'date': '2025-06-05T00:01:44.000+02:00',
    'energyToGrid': 34.3,
    'energyToBattery': 31.4,
    'energyFromSolar': 99.98997,
    'energyConsumed': 93.01109,
    'energyFromBattery': 32.0,
    'energyFromGrid': 19.4,
    'selfConsumptionFromProduction': 34.28997,
    'selfConsumptionFromConsumption': 41.61109,
  },
  {
    'date': '2025-06-06T00:01:44.000+02:00',
    'energyToGrid': 66.1,
    'energyToBattery': 30.6,
    'energyFromSolar': 122.56434,
    'energyConsumed': 65.55507,
    'energyFromBattery': 11.6,
    'energyFromGrid': 15.5,
    'selfConsumptionFromProduction': 25.86434,
    'selfConsumptionFromConsumption': 38.45507,
  },
  {
    'date': '2025-06-07T00:01:44.000+02:00',
    'energyToGrid': 23,
    'energyToBattery': 6.0,
    'energyFromSolar': 36.31025,
    'energyConsumed': 24.31426,
    'energyFromBattery': 5.6,
    'energyFromGrid': 0.5,
    'selfConsumptionFromProduction': 7.31025,
    'selfConsumptionFromConsumption': 18.21426,
  },
  {
    'date': '2025-06-08T00:01:04.000+02:00',
    'energyToGrid': 30.4,
    'energyToBattery': 7.3,
    'energyFromSolar': 43.45903,
    'energyConsumed': 22.50382,
    'energyFromBattery': 7.2,
    'energyFromGrid': 1.1,
    'selfConsumptionFromProduction': 5.75903,
    'selfConsumptionFromConsumption': 14.20382,
  },
  {
    'date': '2025-06-09T00:01:44.000+02:00',
    'energyToGrid': 143.9,
    'energyToBattery': 5.2,
    'energyFromSolar': 134.766,
    'energyConsumed': 17.81311,
    'energyFromBattery': 4.6,
    'energyFromGrid': 0.4,
    'selfConsumptionFromProduction': 14.334,
    'selfConsumptionFromConsumption': 12.81311,
  },
  {
    'date': '2025-06-10T00:01:34.000+02:00',
    'energyToGrid': 93.1,
    'energyToBattery': 10.5,
    'energyFromSolar': 119.46924,
    'energyConsumed': 39.1039,
    'energyFromBattery': 9.6,
    'energyFromGrid': 0.8,
    'selfConsumptionFromProduction': 15.86924,
    'selfConsumptionFromConsumption': 28.7039,
  },
  {
    'date': '2025-06-11T00:01:14.000+02:00',
    'energyToGrid': 83.9,
    'energyToBattery': 13.7,
    'energyFromSolar': 118.6102,
    'energyConsumed': 48.87025,
    'energyFromBattery': 16.5,
    'energyFromGrid': 1.6,
    'selfConsumptionFromProduction': 21.0102,
    'selfConsumptionFromConsumption': 30.77025,
  },
  {
    'date': '2025-06-12T00:01:33.000+02:00',
    'energyToGrid': 31.2,
    'energyToBattery': 7.9,
    'energyFromSolar': 37.59303,
    'energyConsumed': 9.08209,
    'energyFromBattery': 2.7,
    'energyFromGrid': 0.9,
    'selfConsumptionFromProduction': 1.50697,
    'selfConsumptionFromConsumption': 5.48209,
  },
];

export const SAMPLE_YEAR: EnergyBalanceResponse[] = [
  {
    'date': '2025-03-18T18:51:24.000+01:00',
    'energyToGrid': 273.1,
    'energyToBattery': 326.5,
    'energyFromSolar': 0,
    'energyConsumed': 0,
    'energyFromBattery': 314.2,
    'energyFromGrid': 278.9,
    'selfConsumptionFromProduction': 599.6,
    'selfConsumptionFromConsumption': 593.1,
  },
  {
    'date': '2025-04-01T00:01:23.000+02:00',
    'energyToGrid': 1792.5,
    'energyToBattery': 573.5,
    'energyFromSolar': 0,
    'energyConsumed': 0,
    'energyFromBattery': 546.3,
    'energyFromGrid': 342.2,
    'selfConsumptionFromProduction': 2366.0,
    'selfConsumptionFromConsumption': 888.5,
  },
  {
    'date': '2025-05-01T00:01:27.000+02:00',
    'energyToGrid': 2091,
    'energyToBattery': 543.7,
    'energyFromSolar': 2878.07512,
    'energyConsumed': 1345.56276,
    'energyFromBattery': 511.4,
    'energyFromGrid': 133.1,
    'selfConsumptionFromProduction': 243.37512,
    'selfConsumptionFromConsumption': 701.06276,
  },
  {
    'date': '2025-06-01T00:01:04.000+02:00',
    'energyToGrid': 747.7,
    'energyToBattery': 204.4,
    'energyFromSolar': 1128.0368,
    'energyConsumed': 593.92436,
    'energyFromBattery': 196.4,
    'energyFromGrid': 71.3,
    'selfConsumptionFromProduction': 175.9368,
    'selfConsumptionFromConsumption': 326.22436,
  },
];

export const SAMPLE_TOTAL: EnergyBalanceResponse[] = [
  {
    'date': '2024-12-31T23:00:00.000Z',
    'energyToGrid': 5701.5,
    'energyToBattery': 1673.8,
    'energyFromSolar': 6201.4996,
    'energyConsumed': 2822.80758,
    'energyFromBattery': 1593.1,
    'energyFromGrid': 835.7,
    'selfConsumptionFromProduction': 194.43752,
    'selfConsumptionFromConsumption': 394.00758,
    'energyFromConsumptionToProduction': 979.36288,
  },
];
